import SemanticModal from '@vue3/components/common/SemanticModal/index.vue'
import TenantCard from '@vue3/components/tenant/TenantCard/index.vue'
import AuthStore from '@vue3/store/auth-store.js'
import BliButton from '@blibli/blue.button/dist/button/blue/Button'
import BliDropdown from '@blibli/blue.dropdown/dist/dropdown/blue/Dropdown'
import BliDropdownTrigger from '@blibli/blue.dropdown/dist/dropdown/blue/DropdownTrigger'
import BliDropdownTriggerChips from '@blibli/blue.dropdown/dist/dropdown/blue/DropdownTriggerChips'
import CommonMixin from '@vue3/mixins/commonMixin.js'
import BliBadge from '@blibli/blue.badge/dist/badge/blue/Badge'
import BliModal from '@blibli/blue.modal/dist/modal/blue/Modal'
import BliModalHeader from '@blibli/blue.modal/dist/modal/blue/ModalHeader'
import BliModalBody from '@blibli/blue.modal/dist/modal/blue/ModalBody'
import BliModalFooter from '@blibli/blue.modal/dist/modal/blue/ModalFooter'
import BliIconSiEdit from '@blibli/blue-dls-library-icon/dist/Edit'
import BliLists from '@blibli/blue.lists/dist/lists/blue/Lists'
import BliList from '@blibli/blue.lists/dist/lists/blue/List'
import CommonStore from '@vue3/store/common-store.js'
import { mapState, mapActions } from 'pinia'
import constants from '@vue3/constants'
import BliField from '@blibli/blue.field/dist/field/blue/Field'
import BliTextField from '@blibli/blue.text-field/dist/text-field/blue/TextField'

const { APPROVAL_PENDING, REJECTED } = constants.companyRegistrationStatus


export default {
  name: 'TenantPicker',
  components: {
    BliModal,
    BliField,
    BliTextField,
    BliModalHeader,
    BliModalBody,
    BliModalFooter,
    BliLists,
    BliList,
    BliBadge,
    BliButton,
    TenantCard,
    BliDropdown,
    SemanticModal,
    BliIconSiEdit,
    BliDropdownTrigger,
    BliDropdownTriggerChips
  },
  props: {
    showTenantPicker: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      isLogoutModalVisible: false,
      selectedTenant: '',
      selectedCompany: [],
      currentCompany: '',
      selectedCompanyName: [],
      isCompanySwitchInprogress: false,
      cookieInfo: '',
      showNickNameEditModal: false,
      nickName: '',
      companyIdEditingNickname: null,
      isUpdatingNickname: false,
      isDropdownActive: false
    }
  },
  mixins: [CommonMixin],
  mounted () {
    this.initValue()
  },
  watch: {
    currentCompanyId (value) {
      if (this.isFromLoginPage) {
        return
      }
      this.selectedCompany[0] = value
      this.selectedCompanyName[0] = this.currentCompanyInfo.companyName
    },
    showNickNameEditModal (newValue) {
      if (newValue) {
        this.isDropdownActive = false
      }
    }
  },
  computed: {
    ...mapState(AuthStore, ['currentCompanyId']),
    ...mapState(CommonStore, ['registrationId', 'isTenantAlreadySelected']),
    showTenantSelectionModal () {
      return this.showTenantPicker && !this.isLogoutModalVisible
    },
    companyInfoList () {
      return this.tenantList?.find(item => item.tenantId === this.selectedTenant)?.companyList || []
    },
    dropdownLabel () {
      return this.isFromLoginPage ? this.$t('tenantPicker.orderFor') : this.$t('tenantPicker.switchAccount')
    },
    disableSwitchDropdown () {
      return !this.selectedTenant || this.companyInfoList.length === 1
    },
    companyRegistrationStatus () {
      return this.currentCompanyInfo?.companyRegistrationStatus || ''
    },
    isRegistrationStatusPendingOrRejected () {
      return this.companyRegistrationStatus === REJECTED || this.companyRegistrationStatus === APPROVAL_PENDING
    },
    isFromLoginPage () {
      return !this.isTenantAlreadySelected || this.isRegistrationStatusPendingOrRejected
    },
    disableSaveNickName () {
      return !this.nickName?.trim().length ||
      this.nickName?.trim() === this.companyInfoList.find(item => item.companyId === this.companyIdEditingNickname)?.nickname.trim()
    }
  },
  methods: {
    ...mapActions(AuthStore, ['switchCompany', 'getUserInfo', 'resetUserDetails', 'logoutUser', 'updateNickName']),
    ...mapActions(CommonStore, ['setAppLoader']),
    initValue () {
      const preselectedData = this.getPreselectedData()
      this.selectedTenant = preselectedData.tenantId
      this.selectedCompany[0] = preselectedData.companyId
      this.selectedCompanyName[0] = preselectedData.companyName
    },
    preselectCompanyBasedOnTenant () {
      const [firstCompany] = this.companyInfoList
      this.selectedCompany[0] = firstCompany?.companyId || ''
      this.selectedCompanyName[0] = firstCompany?.companyName || ''
    },
    getPreselectedData () {
      if (this.isFromLoginPage) {
        if (this.isUserMappedWithSingleTenant) {
          const firstTenantFromList = this.tenantList[0]
          const firstCompanyFromList = firstTenantFromList?.companyList?.[0]
          return {
            tenantId: firstTenantFromList?.tenantId || '',
            companyId: firstCompanyFromList?.companyId || '',
            companyName: firstCompanyFromList?.companyName || ''
          }
        } else {
          return {
            tenantId: '',
            companyId: '',
            companyName: ''
          }
        }
      }
      return {
        tenantId: this.currentTenantId || '',
        companyId: this.currentCompanyId || '',
        companyName: this.currentCompanyInfo?.companyName || ''
      }
    },
    toggleLogoutConfimation () {
      this.isLogoutModalVisible = !this.isLogoutModalVisible
    },
    handleLogout () {
      this.resetUserDetails()
      this.setShowTenantPickerModal({ showModal: false, isTenantAlreadySelected: false })
      this.toggleLogoutConfimation()
      this.handleClearUserData()
    },
    handleTenantSelect (value) {
      this.selectedTenant = value
      this.preselectCompanyBasedOnTenant()
    },
    handleCompanySelect (name) {
      this.selectedCompanyName[0] = name
    },
    handleSwitchCompany () {
      if (this.isCompanySwitchInprogress) {
        return
      }
      this.isCompanySwitchInprogress = true
      if (this.selectedCompany[0] === this.currentCompanyId) {
        this.setShowTenantPickerModal({ showModal: false, isTenantAlreadySelected: false })
        return
      }
      this.switchCompany({
        data: {
          companyId: this.selectedCompany[0],
          tenantId: this.selectedTenant,
          registrationId: this.registrationId
        },
        success: this.switchCompanySuccess,
        fail: this.switchCompanyFailure
      })
    },
    switchCompanySuccess (resBody) {
      this.isCompanySwitchInprogress = false
      this.cookieInfo = resBody.value.cookieInfo
      this.setAppLoader(true)
      this.getUserInfo({ success: this.onSuccessOfGetUserInfo, fail: this.onFailOfGetUserInfo })
    },
    onSuccessOfGetUserInfo () {
      if (this.isIOSApp) {
        this.postMessageToIOSLoginListener(this.cookieInfo)
      }
      this.$router.go(0)
    },
    switchCompanyFailure () {
      this.setAppLoader(false)
      this.setShowTenantPickerModal({ showModal: false, isTenantAlreadySelected: false })
      this.handleClearUserData()
    },
    onFailOfGetUserInfo () {
      this.setShowTenantPickerModal({ showModal: false, isTenantAlreadySelected: false })
    },
    handleCloseModal () {
      if (this.isFromLoginPage) {
        this.toggleLogoutConfimation()
        return
      }
      this.setShowTenantPickerModal({ showModal: false, isTenantAlreadySelected: false })
    },
    handleNickNameEdit (event, companyId) {
      event.stopPropagation()
      this.showNickNameEditModal = true
      this.nickName = this.companyInfoList.find(item => item.companyId === companyId)?.nickname
      this.companyIdEditingNickname = companyId
    },
    closeNickNameEditModal () {
      this.isUpdatingNickname = false
      this.showNickNameEditModal = false
      this.nickName = ''
      this.companyIdEditingNickname = null
      this.$nextTick(() => {
        this.isDropdownActive = true
      })
    },
    onClearNickName () {
      this.nickName = ''
    },
    trimSpace () {
      this.nickName = this.nickName.trim()
    },
    preventSpecialCharacters (event) {
      const restrictedChars = /[!<>()&*^%$#]/
      const inputChar = String.fromCharCode(event.keyCode || event.which)
      if (restrictedChars.test(inputChar)) {
        event.preventDefault()
      }
    },
    handleInputOnPaste (evt) {
      evt.preventDefault()
      let data = evt.clipboardData.getData('text')
      data = data.replace(/[!<>()&*^%$#]/g, '')
      const input = evt.target
      const start = input.selectionStart
      const end = input.selectionEnd
      const currentValue = this.nickName
      const newValue = currentValue.substring(0, start) + data + currentValue.substring(end)
      this.nickName = newValue
      this.$nextTick(() => {
        input.setSelectionRange(start + data.length, start + data.length)
      })
    },
    onSaveNickName () {
      if (this.isUpdatingNickname) {
        return
      }
      this.isUpdatingNickname = true
      this.updateNickName({
        selectedTenant: this.selectedTenant,
        data: {
          nickname: this.nickName,
          childCompanyId: this.companyIdEditingNickname
        },
        success: this.onSuccessOfUpdateNickName,
        fail: this.onFailOfUpdateNickName
      })
    },
    onSuccessOfUpdateNickName () {
      this.showToast('', this.$t('tenantPicker.nickName.labelUpdated'))
      this.closeNickNameEditModal()
    },
    onFailOfUpdateNickName () {
      this.showToast('error', this.$t('tenantPicker.nickName.labelUpdateFail'))
      this.closeNickNameEditModal()
    }
  }
}
